export default "__VITE_ASSET__d7d7fde7__"